//#region types
import { InvoiceAmountSectionProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { CurrencyDisplayProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import {
  ReadOnlyVerticalFormField,
  CurrencyDisplay,
  TextDisplay,
  GroupSectionInline,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
import { useSearchService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const InvoiceAmountSection: React.FC<InvoiceAmountSectionProps> = (props) => {
  const searchService = useSearchService();
  const { currency, values } = props;

  return (
    <GroupSectionInline
      key={`invoice-amount-section`}
      label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Amount)}
      icon={IconDefinitionConstants.WCalculator}
    >
      <Grid item xs={6}>
        <ReadOnlyVerticalFormField<CurrencyDisplayProps>
          Component={CurrencyDisplay}
          value={values.amountExcludingVat}
          label={TranslationKeys.Common.AmountExVat}
          currency={currency}
        />
      </Grid>
      <Grid item xs={6}>
        <ReadOnlyVerticalFormField<CurrencyDisplayProps>
          Component={CurrencyDisplay}
          value={values.amountIncludingVat}
          label={TranslationKeys.Common.AmountInclVAT}
          currency={currency}
        />
      </Grid>
      <Grid item xs={6}>
        <ReadOnlyVerticalFormField<CurrencyDisplayProps>
          Component={CurrencyDisplay}
          value={values.vat}
          label={TranslationKeys.Common.VAT}
          currency={currency}
        />
      </Grid>
      {!!values.currency && (
        <Grid item xs={6}>
          <ReadOnlyVerticalFormField<DisplayProps>
            Component={TextDisplay}
            value={values.currency}
            label={TranslationKeys.Common.Currency}
            items={searchService.currency}
          />
        </Grid>
      )}
    </GroupSectionInline>
  );
};

export default InvoiceAmountSection;
